import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMicrosoft",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(r).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function m(t, i, l, u, _, e) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--microsoft"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Microsoft",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...i[0] || (i[0] = [
    a("path", {
      d: "M11.5 2H2v9.5h9.5V2z",
      fill: "#F25022"
    }, null, -1),
    a("path", {
      d: "M22 2h-9.5v9.5H22V2z",
      fill: "#7FBA00"
    }, null, -1),
    a("path", {
      d: "M11.5 12.5H2V22h9.5v-9.5z",
      fill: "#00A4EF"
    }, null, -1),
    a("path", {
      d: "M22 12.5h-9.5V22H22v-9.5z",
      fill: "#FFB900"
    }, null, -1)
  ])], 10, f);
}
const z = /* @__PURE__ */ s(c, [["render", m]]);
export {
  z as default
};
//# sourceMappingURL=microsoft.js.map
